import { Status } from '-/Common/Status'
import { SIMPLE_REVIEW_STATUS_COLOR, SIMPLE_REVIEW_STATUS_LABEL } from '@/constant'
import {
  ZCH_REVIEW_STATUS_COLOR,
  ZCH_REVIEW_STATUS_LABEL,
  PENSION_INSURANCE_REVIEW_STATUS_COLOR,
  PENSION_INSURANCE_REVIEW_STATUS_LABEL,
  PROJ_PROGRESS_STATUS_COLOR,
  PROJ_PROGRESS_STATUS_LABEL
} from '@/constant/biz'
export interface StatusProps<S = boolean> {
  value: S
}

const _renderStatus = (type: string, name: string) => <Status type={type}>{name}</Status>

/**
 * @component 简单的审核-状态
 * @param {Object} props props
 * @param {number} props.value 状态值 -1:待审核 0:驳回 1:同意
 */
export const SimpleReviewStatus = (props: StatusProps<number>) =>
  _renderStatus(SIMPLE_REVIEW_STATUS_COLOR[props.value], SIMPLE_REVIEW_STATUS_LABEL[props.value])

/**
 * @component 集体土地项目-被征地农民养老保险-审核状态
 * @param {Object} props props
 * @param {boolean} props.value 状态值
 */
export const PensionInsuranceReviewStatus = (props: StatusProps<number>) =>
  _renderStatus(PENSION_INSURANCE_REVIEW_STATUS_COLOR[props.value], PENSION_INSURANCE_REVIEW_STATUS_LABEL[props.value])

/**
 * @component 项目步骤进度-状态
 * @param {Object} props props
 * @param {boolean} props.value 状态值
 */
export const ProjProcessStatus = (props: StatusProps<number>) =>
  props.value ? _renderStatus(PROJ_PROGRESS_STATUS_COLOR[props.value], PROJ_PROGRESS_STATUS_LABEL[props.value]) : <>未设置</>

/**
 * @component 集体土地-征拆户-社保购买情况
 * @param {Object} props props
 * @param {boolean} props.value 状态值
 */
export const JtZchSocialSecurityStatus = (props: StatusProps<boolean>) => {
  const status = props.value ? '已购买' : '未购买'
  const type = props.value ? 'success' : 'error'
  return _renderStatus(type, status)
}
/**
 * @component 征拆户-审核状态
 * @param {Object} props props
 * @param {number} props.value 状态值
 */
export const ZchReviewStatus = (props: StatusProps<number>) =>
  _renderStatus(ZCH_REVIEW_STATUS_COLOR[props.value], ZCH_REVIEW_STATUS_LABEL[props.value])
